/** 不需登入即可造訪的 public 路徑。 */
const PUBLIC_PATHS = ['/login', '/forgot-password']

/**
 * 全域路由守衛：
 * - 未登入造訪非 public 頁 → 導回 /login
 * - 已登入造訪 /login → 導向 /
 * - 已登入但 profile 未載入（重整 / 新 tab）→ 補抓 profile，
 *   讓 hasRole() 等 role-based UI 守衛能正確判斷
 *
 * SSR 注意：isLoggedIn 讀 Pinia store，不讀 useCookie。
 * useCookie 在 SSR 只讀 request cookie，clearSession 清完後同一 request 內
 * 後續 middleware 仍會看到 stale request cookie → 觸發 redirect loop（fetchProfile 401
 * → 清 session + 導 /login → /login 看到 request cookie 判 isLoggedIn=true 又導 / → 無限）。
 * Pinia store 是 per-SSR-request singleton，clearSession 後同 request 內讀到 null，
 * 才是「當前 session state」的正確 source of truth。
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const isPublic = PUBLIC_PATHS.includes(to.path)
  const auth = useAuthStore()
  const isLoggedIn = !!auth.token

  if (!isLoggedIn && !isPublic) {
    return navigateTo('/login')
  }
  if (isLoggedIn && to.path === '/login') {
    return navigateTo('/')
  }

  // 已登入但 in-memory profile 不見（重整、新 tab），重抓一次
  if (isLoggedIn && !auth.profile) {
    try {
      await auth.fetchProfile()
    }
    catch {
      // 401 / 網路錯 → $api plugin 已 clearSession。middleware 顯式 return navigateTo
      // 中止 target page 繼續 render，避免瀏覽器先閃一下破 UI 才被 async redirect 追上。
      // 帶 `?expired=1` flag → /login 頁 mount 時顯示 toast「登入憑證已過期」
      // （SSR 上 api plugin 的 toast 分支只在 client 端執行，hard reload 場景 client 沒機會 fire）。
      return navigateTo('/login?expired=1')
    }
  }
})
